import React, { useState } from "react";
import { MainContainer, MainHeading, ProductsHeader, SearchRow, ActionsRow } from "./styles";
import { Input, Modal } from "antd";
import UsersListing from "./UsersListing";
import UserForm from "./UserForm";
import AntButton from "../../uiKits/Button";
const { Search } = Input;

const UsersComponent = () => {
  const [searchInput, setSearchInput] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setSearchFilter(searchInput.trim());
    }, 500);

    return () => clearTimeout(timer);
  }, [searchInput]);

  const handleSearch = (event) => {
    setSearchInput(event.target.value);
  };

  return (
    <MainContainer>
      <MainHeading>Users</MainHeading>

      <ProductsHeader>
        <SearchRow>
          <Search
            placeholder="Search users"
            value={searchInput}
            onSearch={(value) => setSearchInput(value)}
            onChange={handleSearch}
          />
        </SearchRow>
        <ActionsRow>
          <AntButton onClick={() => setIsUserModalOpen(true)}>Add User</AntButton>
        </ActionsRow>
      </ProductsHeader>
      <UsersListing searchFilter={searchFilter} />

      <Modal
        title="Add User"
        open={isUserModalOpen}
        footer={null}
        onCancel={() => setIsUserModalOpen(false)}
        destroyOnClose
        width={720}
      >
        <UserForm onUserAdded={() => setIsUserModalOpen(false)} embedded />
      </Modal>
    </MainContainer>
  );
};

export default UsersComponent;
